import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortArrowDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 9,
	viewBox: "0 0 8 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4 8L4 -4.47035e-08",
		stroke: "#AFAFAF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7 5L4 8L1 5",
		stroke: "#AFAFAF"
	})]
});
export default SvgSortArrowDown;
